import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';

export class TermsCondition {

 private _title: Map<string,string>;
 private _description: Map<string,string>;
 private _type: string;

  constructor() {
    this._title = new Map();
    this._description = new Map();
    this._type = "";
  }


  fromJson(data: TermsCondition){
    this.description = GetSafeValue.getSafeValueAsMap(data[StringFieldUtil.description], {'en': "", 'kh': ""});
    this.title = GetSafeValue.getSafeValueAsMap(data[StringFieldUtil.title], {'en': "", 'kh': ""});
    this.type = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.type], "");
  }

  clone(data : TermsCondition){
    this.title = data.title;
    this.description = data.description;
    this.type = data.type;
  }

  get title(): Map<string, string> {
    return this._title;
  }

  set title(value: Map<string, string>) {
    this._title = value;
  }

  get description(): Map<string, string> {
    return this._description;
  }

  set description(value: Map<string, string>) {
    this._description = value;
  }


  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  toMap(){
    return {
      "title": {
        'en': this.title['en'],
        'kh': this.title['kh']
      },
      "description": {
        'en': this.description['en'],
        'kh': this.description['kh'],
      }
    }
  }

  toMapBank(){
    return {
      "title": {
        'en': this.title['en'],
        'kh': this.title['kh']
      },
      "description": {
        'en': this.description['en'],
        'kh': this.description['kh'],
      },
      "type" : this.type
    }
  }
}
